import { render, staticRenderFns } from "./more_button.vue?vue&type=template&id=e5848b94&scoped=true&lang=pug"
import script from "./more_button.vue?vue&type=script&lang=js"
export * from "./more_button.vue?vue&type=script&lang=js"
import style0 from "./more_button.vue?vue&type=style&index=0&id=e5848b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5848b94",
  null
  
)

export default component.exports